import React from 'react';

// GraphQl
import { useQuery } from '@apollo/react-hooks';

// Components & Others
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import LoadingIndicator from '../../../LoadingIndicator';
import PropertyRegimeForm from '../PropertyRegimeForm';
import { GET_PROPERTY_REGIME } from '../queries';
import { parseBool } from '../../../../utils/commonFunctions';

function PropertyRegimeEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_PROPERTY_REGIME, {
    variables: { id },
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    console.error(error);
    history.goBack();
  }

  const formatValue = { ...data.propertyRegime };
  if (!data.propertyRegime) {
    history.goBack();
  }

  formatValue.society = parseBool(formatValue.society);

  return <PropertyRegimeForm propertyRegime={formatValue} id={id} isEdit />;
}

PropertyRegimeEdit.propTypes = {};

export default PropertyRegimeEdit;
